import styled from 'styled-components';
// Styles
import { colors } from '../../../../styles/variables';

/**
 * Container principal da tabela de cobertura
 */
export const CoverageContainer = styled.div`
  width: 100%;
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
  border: 1px solid ${colors.grey.darkSecondary};
  border-radius: 5px;
  overflow: hidden;
`;

/**
 * Nota informativa acima da tabela
 */
export const CoverageNote = styled.p`
  font-size: 0.75rem;
  color: ${colors.grey.dark || '#666'};
  padding: 0.5rem 0.75rem;
  margin: 0;
  background-color: ${colors.grey.light || '#f9f9f9'};
  border-bottom: 1px solid ${colors.grey.darkSecondary};
`;

/**
 * Tabela de cobertura
 */
export const CoverageTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
`;

/**
 * Linha de cabeçalho
 */
export const CoverageHeader = styled.tr`
  background-color: ${colors.primary || '#1a3a6b'};
`;

/**
 * Célula do cabeçalho
 */
export const CoverageHeaderCell = styled.th`
  padding: 0.6rem 0.75rem;
  text-align: left;
  color: #fff;
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;

  &:nth-child(2),
  &:nth-child(3) {
    text-align: right;
  }
`;

/**
 * Linha da tabela
 */
export const CoverageRow = styled.tr`
  border-bottom: 1px solid ${colors.grey.darkSecondary || '#e0e0e0'};

  &:last-child {
    border-bottom: none;
  }

  &:nth-child(even) {
    background-color: ${colors.grey.light || '#f5f5f5'};
  }

`;

/**
 * Célula da tabela
 */
export const CoverageCell = styled.td`
  padding: 0.6rem 0.75rem;
  font-size: 0.85rem;
  color: ${colors.grey.darker || '#333'};

  &:nth-child(2),
  &:nth-child(3) {
    text-align: right;
    font-weight: 500;
  }
`;

/**
 * Label do percentual de cobertura
 */
export const CoverageLabel = styled.span`
  font-weight: 600;
  color: ${colors.primary || '#1a3a6b'};
`;